<template>
    <van-popup v-model:show="show" @click-overlay="close" position="bottom" :style="{
        minWidth: '100%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }">
        <div class="popupContainer">
            <van-row class="headBar">
                <van-col span="5">
                    <div class="logo">
                        <img src="@/assets/themetwo/logo2-2.png" alt="">
                    </div>
                </van-col>
                <van-col span="15" style="padding: 10px;">
                    <div class="text1">{{ $t('pwa.text1') }}</div>
                    <div class="text2">{{ $t('pwa.text2') }}</div>
                </van-col>
                <van-col span="1" offset="3">
                    <div class="closeIcon">
                        <img src="@/assets/themetwo/Close_02-1.png" alt="" @click="close">
                    </div>
                </van-col>
            </van-row>

            <div style="padding: 0 20px;">
                <div class="title">{{ $t('pwa.title') }}</div>
                <div style="padding: 0 20px;">
                    <div class="detailsBg">
                        <div class="infoText">
                            {{ title }}
                        </div>
                    </div>

                </div>
            </div>

            <div style="padding: 15px;">
                <div class="title2">{{ $t('pwa.installIntroTitle') }}</div>
                <div class="installInfo" v-html="$t('pwa.installIntro1')"></div>


                <div class="introCard">
                    <div class="title3">{{ $t('pwa.installIntroTitle') }}</div>
                    <div class="installInfo2">{{ $t('pwa.installIntro2') }}</div>
                </div>
            </div>

        </div>

    </van-popup>
    <ContactServicePopup ref="contactRef" />
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, defineExpose } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { useUserStore } from '@/stores/user';
const userStore = useUserStore()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const title = ref('')
const contactRef = ref()

const open = (value: string) => {
    show.value = true
    title.value = value
    userStore.setPwaShowing(false)
}


const close = () => {
    show.value = false
    contactRef.value.close()
    userStore.setPwaShowing(false)
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const openContactPopup = () => {
    contactRef.value.open()
}

defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background: #221b24;
    border-radius: 25px 25px 0 0;
    width: 100%;
    overflow: hidden;
}

.van-overlay {
    z-index: 9999 !important;
    backdrop-filter: blur(.26667rem);
}

.headBar {
    background-image: url('@/assets/themetwo/Dow_Bg.png');
    background-size: cover;
    background-repeat: repeat;
    padding: 10px;

}

.logo img {
    width: 70%;
    padding: 10px;
}

.text1 {
    font-weight: bold;
    color: #ffffffd9;
    padding-bottom: 10px;
    font-size: 15px;
}

.text2 {
    color: #ffffffa6;
}

.closeIcon {
    display: flex;
    justify-content: right;
}

.closeIcon img {
    width: 25px;
    padding: 2px;
    background-color: #000;
    border-radius: 30px;
}

.bannerImg {
    padding: 5px;
}

.bannerImg img {
    width: 100%;
}

.title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    padding: 15px 0 5px;
    color: #fff;
}

.title2 {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding-bottom: 10px;
}

.installInfo {
    color: #86718c;
    font-size: 12px;
    padding: 5px 0;
}

.introCard {
    background: #312734;
    padding: 10px;
    border-radius: 5px;
}

.title3 {
    color: #fff;
    font-size: 15px;
    padding-bottom: 10px;
}

.installInfo2 {
    color: #86718c;
    font-size: 12px;
}

.detailsBg {
    margin-bottom: 15px;
    padding: 15px 10px;
}

.infoText {
    display: flex;
    justify-content: center;
    color: #c92222;
    font-size: 16px;
    padding: 5px;
    font-weight: bold;
}

.bonusBar {
    background: #00000014;
    color: #000000a6;
    border-radius: 30px;
    padding: 15px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.bonusBar span {
    color: #7800BB;
    font-size: 17px;
}

.bonusBar img {
    width: 25px;
    padding-right: 10px;
}

.linkBtn {
    background-image: linear-gradient(180deg, #F39A4F 0%, #78340F 100%);
    border: 1.5px solid rgba(249, 196, 134, 1);
    padding: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    color: #FFFFFF;
    font-size: 15px;
    width: 90%;
}

.linkBtn img {
    width: 25px;
    padding-right: 10px;
}

.serviceIcon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.serviceIcon img {
    width: 40%;
    padding: 12px;
    border-radius: 30px;
    background: #00000040;
}

.alignment {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>